import Feature from "../Feature";
import { userStore } from "../store";

const hasBetaFeature = (feature: Feature) => userStore.user.beta_features.includes(feature);

export default hasBetaFeature;
